/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function () {var a={};var f=/iPhone/i,h=/iPod/i,i=/iPad/i,r=/\biOS-universal(?:.+)Mac\b/i,g=/\bAndroid(?:.+)Mobile\b/i,j=/Android/i,c=/(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i,d=/Silk/i,b=/Windows Phone/i,k=/\bWindows(?:.+)ARM\b/i,m=/BlackBerry/i,n=/BB10/i,o=/Opera Mini/i,p=/\b(CriOS|Chrome)(?:.+)Mobile/i,q=/Mobile(?:.+)Firefox\b/i;function s(l){return function($){return $.test(l)}}function e(l){var $=(l=l||("undefined"!=typeof navigator?navigator.userAgent:"")).split("[FBAN");void 0!==$[1]&&(l=$[0]),void 0!==($=l.split("Twitter"))[1]&&(l=$[0]);var a=s(l),e={apple:{phone:a(f)&&!a(b),ipod:a(h),tablet:!a(f)&&a(i)&&!a(b),universal:a(r),device:(a(f)||a(h)||a(i))&&!a(b)},amazon:{phone:a(c),tablet:!a(c)&&a(d),device:a(c)||a(d)},android:{phone:!a(b)&&a(c)||!a(b)&&a(g),tablet:!a(b)&&!a(c)&&!a(g)&&(a(d)||a(j)),device:!a(b)&&(a(c)||a(d)||a(g)||a(j))||a(/\bokhttp\b/i)},windows:{phone:a(b),tablet:a(k),device:a(b)||a(k)},other:{blackberry:a(m),blackberry10:a(n),opera:a(o),firefox:a(q),chrome:a(p),device:a(m)||a(n)||a(o)||a(q)||a(p)},any:!1,phone:!1,tablet:!1};return e.any=e.apple.universal||e.apple.device||e.android.device||e.windows.device||e.other.device,e.phone=e.apple.phone||e.android.phone||e.windows.phone,e.tablet=e.apple.tablet||e.android.tablet||e.windows.tablet,e}a=e();if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=a}else if(typeof define==="function"&&define.amd){define(function(){return a})}else{this["isMobile"]=a}})();
(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {

				var _this = this;
				var $window = $(window);

				var mt = jQuery('header.banner').height();
				mt += parseFloat(  jQuery('header.banner').css('padding-top') );
				mt += parseFloat(  jQuery('header.banner').css('padding-bottom') );

				if( !isMobile.any ) {
					$('.text-5').attr( 'data-margin-top', mt );
					$('.text-5').attr( 'data-sticky-class', "is-sticky" );
					var sticky = new Sticky('.text-5');
				}

				setTimeout( function () {
					if( !isMobile.any ) {
						$('.text-5').attr( 'data-sticky-class', "is-sticky" );
						mt = jQuery('header.banner').height();
						mt += parseFloat(  jQuery('header.banner').css('padding-top') );
						mt += parseFloat(  jQuery('header.banner').css('padding-bottom') );
						$('.text-5').attr( 'data-margin-top', mt );
						var sticky = new Sticky('.text-5');
					}
				}, 2000 );
				$window.resize(function() {
					if( !isMobile.any ) {
						//mt = jQuery('header.banner').height();
						//mt += parseFloat(  jQuery('header.banner').css('padding-top') );
						//mt += parseFloat(  jQuery('header.banner').css('padding-bottom') );
						$('.text-5').attr( 'data-margin-top', mt );
						$('.text-5').attr( 'data-sticky-class', "is-sticky" );
						var sticky = new Sticky('.text-5');
					}
				});

				// JavaScript to be fired on all pages
				$('.navbar-toggler').click( function () {
					$('#navbarSupportedContent').toggleClass('openleft');
				} );

				var pic = new Image();
				pic.src = object_data.logo_small;
				$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
					//disableOn: 700,
					type: 'iframe',
					//mainClass: 'mfp-fade',
					//removalDelay: 160,
					preloader: false,
					fixedContentPos: true
				});
				$('button.navbar-toggle').magnificPopup({
					fixedContentPos: true,
					mainClass: 'mfp-fade',
					fixedBgPos: true,
					items: {
						src: '#menu-mainmenu',
						type: 'inline'
					},
					closeOnBgClick: false,
					//midClick: true
				});
				$(window).scroll(function( e ){
					//$('.text-5').addClass( "is-sticky" );
					if( !isMobile.any ) {
						mt = jQuery('header.banner').height();
						mt += parseFloat(  jQuery('header.banner').css('padding-top') );
						mt += parseFloat(  jQuery('header.banner').css('padding-bottom') );
						$('.text-5').attr( 'data-sticky-class', "is-sticky" );
						$('.text-5').attr( 'data-margin-top', mt );
						var sticky = new Sticky('.text-5');

						if ( jQuery(window).scrollTop() > 150 ) {
							$('.text-5').addClass( "is-sticky" );
						} else {
							$('.text-5').removeClass( "is-sticky" );
						}
					}
					
					if( 800 > jQuery( 'body' ).height() - jQuery(window).scrollTop()  ){
						$('.shareaholic-share-buttons-container[data-app="floated_share_buttons"]').fadeOut(0);
					} else {
						$('.shareaholic-share-buttons-container[data-app="floated_share_buttons"]').fadeIn(0);
					}
				});

				if ( $('#billing_desea_factura').val() == 'Si' ) {
					$('.show_invoice').fadeIn();
				}
				else {
					$('.show_invoice').fadeOut();
					$('#billing_ruc').val('');
					$('#billing_razon_social').val('');
					$('#billing_address_invoice').val('');
				}
				$(document).on( 'change','#billing_desea_factura', function ( ) {
					if ( $(this).val() == 'Si' ) {
						$('.show_invoice').fadeIn();
					}
					else {
						$('.show_invoice').fadeOut();
						$('#billing_ruc').val('');
						$('#billing_razon_social').val('');
						$('#billing_address_invoice').val('');
					}	
				} );

				/*
				$('#navbarSupportedContent').on('hidden.bs.collapse', function () {
					$('#navbarSupportedContent').removeAttr('style');
					$('body').removeAttr('style');
				});
				$('#navbarSupportedContent').on('shown.bs.collapse', function () {
					$('body').css( {
						'overflow-y': 'hidden'
					} );
					$('#navbarSupportedContent').css({
						left: 0,
						width: '100%',
						background: 'white',
						'z-index': 999,
						'min-height': '640px',
					});
				});
				*/
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				var elementPosition;
				var body = $('body');
				var header = $('header.banner');
				var h = header.height() + parseInt( header.css('padding-top') ) + parseInt(header.css('padding-bottom'));
				$(window).scroll(function( e ){
					elementPosition = header.offset();
					if( $(window).scrollTop() > h/2 ){
						header.addClass('fixed');
						body.addClass('has-fixed');
					} else {
						header.removeClass('fixed');
						body.removeClass('has-fixed');
					}
				});
				$(window).resize(function(){
					h = header.height() + parseInt( header.css('padding-top') ) + parseInt(header.css('padding-bottom'));
				});
			}
		},

		'finalizar_comprar': {
			init: function() {
				console.log( 'ssss ');
				if ( $('#billing_desea_factura').val() == 'Si' ) {
					$('.show_invoice').fadeIn();
				}
				else {
					$('.show_invoice').fadeOut();
					$('#billing_ruc').val('');
					$('#billing_razon_social').val('');
					$('#billing_address_invoice').val('');
				}
				$(document).on( 'change','#billing_desea_factura', function ( ) {
					if ( $(this).val() == 'Si' ) {
						$('.show_invoice').fadeIn();
					}
					else {
						$('.show_invoice').fadeOut();
						$('#billing_ruc').val('');
						$('#billing_razon_social').val('');
						$('#billing_address_invoice').val('');
					}	
				} );
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				/*
				var _this = this;
				var logo_position;
				var h_logo = $('header.banner .content_logo img');
				var logo = $('body.home .main .logo');
				logo.css({
					width: h_logo.width(),
				});
				var logo_of = logo.offset();
				logo.css({
					'margin-left': h_logo.offset().left - logo_of.left,
				});
				
				$('.main p').textillate({ 
					minDisplayTime: 1500,
					loop: false,
					//initialDelay: 1000,
					inEffects: ['pulseIn'],
					outEffects: [ 'pulseOut' ],
					in: {
						effect: 'pulseIn',
						sync: false,
						shuffle: false,
						reverse: false,
						delay: 30,
						callback: function () {
							setTimeout( function() {
								$('.main p').textillate('out');
							}, 500);
						}
					},
					out: { 
						effect: 'fadeOut',
						delay: 30,
						sync: true,
						shuffle: false,
						reverse: true,
						callback: function () {
							var ww = $(window).width();
							var h_b = $('header.banner');
							var h_b_p = parseInt( h_b.css('padding-left') );
							var h_b_l = h_b.find('.left').width();
							var h_b_r = h_b.find('.right').width();
							logo_position = $('.logo').offset();
							var c_logo = ( ww - ( h_b_p * 2 ) - h_b_l - h_b_r - $('.logo').width() );
							c_logo *= 0.5;
							$('body.home header.banner').velocity({
								top: logo_position.top, 
							}, {
								duration: 500,
								easing: 'linear',
								complete: function( ) {
									//$('.logo').detach().appendTo('.content_logo');
									//_this.animateFooter();
								}
							});		
						}
					},
				});
				*/

				/*
				var _this = this;
				var logo_position;
				$('.main p').textillate({ 
					minDisplayTime: 1500,
					loop: false,
					//initialDelay: 1000,
					inEffects: ['pulseIn'],
					outEffects: [ 'pulseOut' ],
					in: {
						effect: 'pulseIn',
						sync: false,
						shuffle: false,
						reverse: false,
						delay: 30,
						callback: function () {
							setTimeout( function() {
								$('.main').fadeOut();
								$('.logo').fadeOut();
								$('body.home header.banner').fadeOut();
								setTimeout( function() {
									location.href+= 'work';
								}, 500);
							}, 500);
						}
					},
					out: { 
						effect: 'fadeOut',
						delay: 30,
						sync: true,
						shuffle: false,
						reverse: true,
						callback: function () {
							var ww = $(window).width();
							var h_b = $('header.banner');
							var h_b_p = parseInt( h_b.css('padding-left') );
							var h_b_l = h_b.find('.left').width();
							var h_b_r = h_b.find('.right').width();
							logo_position = $('.logo').offset();
							var c_logo = ( ww - ( h_b_p * 2 ) - h_b_l - h_b_r - $('.logo').width() );
							c_logo *= 0.5;
							$('.logo').fadeOut();
							$('body.home header.banner').fadeOut();
							$('.logo').detach().appendTo('.content_logo').css({
								position: 'absolute',
								left: logo_position.left,
								top: logo_position.top,
							}).velocity({
								top: parseInt( $('header.banner').css('padding-top') ),
								left: h_b_p + c_logo + h_b_l,
							},{
								duration: 1000,
								easing: [ 0.45, 0.01, 0.52, 0.97 ],
							});
							//_this.animateFooter();
						}
					},
				});
				*/
			},
			animateFooter: function ( ) {
				$('body.home header.banner').velocity({
						top: 0, 
					}, {
					duration: 1000,
					easing: [ 0.45, 0.01, 0.52, 0.97 ],
					complete: function( ) { 
						$('body.home header.banner').addClass('header_top');
						$('header.banner .content_logo img').fadeIn();
						setTimeout( function() {
							location.href+= 'work';
						}, 500);
					}
				});
			}
		},
		// About us page, note the change from about-us to about_us.
		'is_referer': {
			init: function() {
				// JavaScript to be fired on the about us page
				//if ( document.referrer == object_data.home_url ) {
					//$('.wrap.container, footer.content-info').fadeOut(0);
					//$('header.banner').fadeOut(0).fadeIn(500);
					$('header.banner').velocity({
						opacity: 1
					}, {
						duration: 1000,
						easing: [ 0.45, 0.01, 0.52, 0.97 ],
					});
					setTimeout( function () {
						$('.wrap.container, footer.content-info').velocity({
							opacity: 1
						}, {
							duration: 1000,
							easing: [ 0.45, 0.01, 0.52, 0.97 ],
						});
					}, 400 );
				//}
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
